module.exports = __webpack_public_path__ + "img/drawer_exit_active.856e439a.svg";